import gql from 'graphql-tag';
import { Fragments } from '@shared/api';

export const listApiKeys = gql`
  query ListApiKeysQuery($input: ListApiKeys!) {
    listApiKeys(input: $input) {
      apiKeys {
        ...ApiKey
      }
      hasMore
    }
  }

  ${Fragments.apiKey.apiKey}
`;
